import { Link } from 'react-router-dom';
import { Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { shouldOfferPwaInstall } from '@/lib/pwa-install';
import { cn } from '@/lib/utils';

interface PwaInstallNavButtonProps {
  className?: string;
  iconClassName?: string;
  variant?: 'ghost' | 'outline' | 'secondary';
  size?: 'icon' | 'sm';
}

export function PwaInstallNavButton({
  className,
  iconClassName,
  variant = 'ghost',
  size = 'icon',
}: PwaInstallNavButtonProps) {
  if (!shouldOfferPwaInstall()) return null;

  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={cn('touch-manipulation', className)}
    >
      <Link to="/install-app" aria-label="Instalar app en el celular" title="Instalar app">
        <Smartphone className={cn('h-4 w-4', iconClassName)} />
        {size === 'sm' && <span className="sr-only sm:not-sr-only sm:ml-1.5">Instalar app</span>}
      </Link>
    </Button>
  );
}
